import { render, staticRenderFns } from "./EducationResults.vue?vue&type=template&id=3f3f505a&scoped=true&"
import script from "./EducationResults.vue?vue&type=script&lang=js&"
export * from "./EducationResults.vue?vue&type=script&lang=js&"
import style0 from "./EducationResults.vue?vue&type=style&index=0&id=3f3f505a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3f505a",
  null
  
)

export default component.exports